export const STATUS = { draf: "Draf", sedia: "Sedia", selesai: "Selesai" };

const list = (xs, p = "- ") => (xs || []).map((x) => `${p}${x}`);
const dalil = (d) => [`Ayat utama: ${d.rujukan}`, d.arab, `Terjemahan (Basmeih): ${d.terjemahan}`,
  ...(d.q.ayat_berkaitan.length ? ["Ayat berkaitan:", ...d.q.ayat_berkaitan.map((a) => `- ${a.rujukan}${a.kaitan ? ` — ${a.kaitan}` : ""}`)] : [])];

const head = (k, title) => [`${title} · ${k.program.tajuk}`, `Peserta: ${k.program.peserta} · Tempoh: ${k.program.tempoh}`, ""];
const NOTA = ["", "Nota: Teks ayat dan terjemahan daripada pangkalan data ATAS. Analisis dan cadangan dijana AI berdasarkan petikan tafsir — semak sebelum digunakan."];

const kuliah = (k, d, l) => [...head(k, "RANGKA KULIAH"), "1. Pembukaan & isu", l.analisis_keperluan, "",
  "2. Dalil", ...dalil(d), "", "3. Mesej teras (Q)", d.q.mesej_teras, "",
  "4. Nilai & prinsip (V)", ...list(d.v.nilai), ...list(d.v.prinsip), "",
  "5. Ilmu & kemahiran (K)", ...list(d.k.ilmu), ...list(d.k.kemahiran), "",
  "6. Inovasi & tindakan (I)", ...d.i.map((x) => `- ${x.nama}: ${x.huraian}`), "",
  "7. Penutup", `Amanah: ${d.amanah}`];

const lesson = (k, d, l) => [...head(k, "LESSON PLAN"), "Objektif pembelajaran:", ...list(l.objektif, "• "), "",
  ...l.rangka_kandungan.flatMap((s, n) => [`Sesi ${n + 1}: ${s.sesi} (${s.masa || "-"}) · Lapis ${s.lapis || "-"}`, ...list(s.isi, "   - "), ""]),
  "Aktiviti:", ...l.aktiviti.map((a) => `- ${a.nama} (${a.masa || "-"}, ${a.kaedah || "-"})`), "", "Penilaian / refleksi:", ...list(l.soalan_refleksi, "• ")];

const refleksi = (k, d, l) => [...head(k, "SOALAN REFLEKSI"), ...l.soalan_refleksi.map((q, n) => `${n + 1}. ${q}`)];

const aktiviti = (k, d, l) => [...head(k, "AKTIVITI KUMPULAN"), ...l.aktiviti.flatMap((a, n) => [
  `${n + 1}. ${a.nama}`, `   Masa: ${a.masa || "-"} · Kaedah: ${a.kaedah || "-"}`, ...a.langkah.map((x, i) => `   ${i + 1}) ${x}`), ...(a.bahan ? [`   Bahan: ${a.bahan}`] : []), ""])];

const slaid = (k, d, l) => [...head(k, "RANGKA SLAID"), `Slaid 1: ${k.program.tajuk}`, `   - ${k.program.peserta}`,
  `Slaid 2: Dalil — ${d.rujukan}`, `   - ${d.terjemahan}`,
  ...l.rangka_slaid.flatMap((s, n) => [`Slaid ${n + 3}: ${s.tajuk}`, ...list(s.poin, "   - ")])];

const tindakan = (k, d, l) => [...head(k, "TINDAKAN PESERTA"), "Selepas program, saya akan:", ...l.tindakan_selepas.map((x, n) => `${n + 1}. ${x}`), "", `Amanah 7 hari: ${d.amanah}`];

const BUILD = { kuliah, lesson, refleksi, aktiviti, slaid, tindakan };

export const VIEWS = [["kuliah", "Rangka Kuliah"], ["lesson", "Lesson Plan"], ["refleksi", "Soalan Refleksi"],
  ["aktiviti", "Aktiviti Kumpulan"], ["slaid", "Rangka Slaid"], ["tindakan", "Tindakan Peserta"]];

export const viewText = (id, k) => {
  const d = k.current;
  return [...BUILD[id](k, d, d.latihan), ...NOTA].join("\n");
};

export const kerangkaText = (k) => {
  const d = k.current, l = d.latihan;
  return [...head(k, "KERANGKA PROGRAM"), "Analisis keperluan peserta:", l.analisis_keperluan, "", ...dalil(d), "",
    "Analisis HTE:", `Q — ${d.q.mesej_teras}`, `V — ${d.v.nilai.join(", ")}`, `K — ${[...d.k.ilmu, ...d.k.kemahiran].join(", ")}`, `I — ${d.i.map((x) => x.nama).join(", ")}`, "",
    "Objektif pembelajaran:", ...list(l.objektif, "• "), "", "Rangka kandungan:",
    ...l.rangka_kandungan.flatMap((s, n) => [`Sesi ${n + 1}: ${s.sesi} (${s.masa || "-"}) · Lapis ${s.lapis || "-"}`, ...list(s.isi, "   - ")]), "",
    "Aktiviti interaktif:", ...l.aktiviti.map((a) => `- ${a.nama} (${a.masa || "-"}, ${a.kaedah || "-"})`), "",
    "Soalan refleksi:", ...list(l.soalan_refleksi, "• "), "", "Tindakan selepas program:", ...list(l.tindakan_selepas, "• "), ...NOTA].join("\n");
};

const fbSummary = (mb) => (mb || []).map((m) => [m.perbaiki && `Peserta: ${m.perbaiki}`, m.cadangan && `Cadangan peserta: ${m.cadangan}`].filter(Boolean).join(". ")).filter(Boolean);

export const aarSummary = (aar, mb) => [...(aar || []).map((a) => [
  a.kurang && `Kurang berkesan: ${a.kurang}`, a.maklum_balas && `Maklum balas peserta: ${a.maklum_balas}`, a.perbaiki && `Perlu diperbaiki: ${a.perbaiki}`,
].filter(Boolean).join(". ")).filter(Boolean), ...fbSummary(mb)].filter((x, i, a) => a.indexOf(x) === i).join(" | ").slice(0, 1900);
